module.exports = __webpack_public_path__ + "static/media/cabfare-logo.84abda4b.png";